import { Observable } from "rxjs";

import { post, put, get } from "@utils/axios";
import sessionService from "./session.service";

class HospitalListCMService {

    fetchFacilities(facilityName? :any): Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/facility-refence-data`);
    }

    fetchHospitalMapping(facilityName? :any, pageMode? :any): Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/hospital-mapping?facilityName=${facilityName}&mode=${pageMode}`);
    }

    fetchHospitalCMColumnConfig() : Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/hospital-mapping-columns`);
    }

    fetchFacilityDependentOptions() : Observable<any> {
        return get(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/facility-options`);
    }

    updateFacilityDependentOptions(facilityObj?:any) : Observable<any> {
        return put(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/facility/edit`, {...facilityObj});
    }

    addNewHospitalMapping(pageName: string, data: any): Observable<any> {
        return post(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/hospital-mapping/create`, {
            pageName: pageName,
            ...data
        })
    }

    editHospitalMapping(pageName: string, data: any): Observable<any> {
        return put(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/hospital-mapping/edit`, {
            pageName: pageName,
            ...data,
            // isDelete: isDelete
        })
    }

    addNewFacility(data: any): Observable<any> {
        return post(`${sessionService.getClient()?.appServiceUrl}/hospitalList-cm/facility/create`, {
            facilityName: data.facilityName,
            county: data.county,
            hospitalListGroup: data.hospitalListGroup,
            facilityType: data.facilityType
        });
    }
}

export default new HospitalListCMService();
